module.exports = __webpack_public_path__ + "img/culture-welcome.e5c6cf7d.png";